import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "grid xl:grid-cols-3 gap-4 pt-6 relative border border-next-gray-md-dark px-3 mb-5 pb-3" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_3 = { class: "flex flex-col pb-3" }
const _hoisted_4 = { class: "flex flex-col pb-3 grow" }
const _hoisted_5 = { class: "flex flex-col mb-3" }
const _hoisted_6 = { class: "flex flex-col text-sm" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = {
  key: 1,
  class: "flex items-center justify-between"
}
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = { class: "flex flex-col mb-3" }
const _hoisted_15 = { class: "flex flex-col mb-3" }
const _hoisted_16 = { class: "flex flex-col mb-3 col-span-2" }
const _hoisted_17 = { class: "grid grid-cols-8 gap-3 mb-3" }
const _hoisted_18 = { class: "col-span-6 flex flex-col" }
const _hoisted_19 = { class: "col-span-2 flex flex-col mb-3" }
const _hoisted_20 = { class: "flex flex-col mb-3" }
const _hoisted_21 = { class: "flex flex-col mb-3" }
const _hoisted_22 = { class: "col flex flex-col mb-3" }
const _hoisted_23 = { class: "flex flex-col mb-3" }
const _hoisted_24 = { class: "flex flex-col mb-3" }
const _hoisted_25 = { class: "flex flex-col mb-3" }
const _hoisted_26 = { class: "grid grid-cols-8 gap-3 mb-3" }
const _hoisted_27 = { class: "col-span-5 flex flex-col" }
const _hoisted_28 = { class: "col-span-3 flex flex-col" }
const _hoisted_29 = { class: "flex flex-col mb-3" }
const _hoisted_30 = { class: "flex flex-col mb-3" }
const _hoisted_31 = { class: "flex gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_MapViewer = _resolveComponent("MapViewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[30] || (_cache[30] = _createElementVNode("h6", { class: "px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray" }, "Dati aziendali", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Field, {
          field_name: "Azienda estera",
          errors: _ctx.getErrors('estera')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Select, {
              modelValue: _ctx.estera,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:estera', $event))),
              disabled: _ctx.disable_dati_azienda
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["errors"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Field, {
          field_name: "Tipo",
          errors: _ctx.getErrors('tipo')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_VueMultiselect, {
              modelValue: _ctx.tipo_model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tipo_model) = $event)),
              options: _ctx.tipo_options,
              multiple: false,
              disabled: _ctx.disable_dati_azienda,
              allowEmpty: false,
              "close-on-select": true,
              "clear-on-select": false,
              selectLabel: "",
              deselectLabel: "",
              selectedLabel: "",
              placeholder: "Tipo cliente",
              class: "next-vue-multiselect-single",
              "track-by": "id",
              label: "text"
            }, {
              noResult: _withCtx(() => _cache[23] || (_cache[23] = [
                _createTextVNode("Nessun elemento trovato.")
              ])),
              _: 1
            }, 8, ["modelValue", "options", "disabled"])
          ]),
          _: 1
        }, 8, ["errors"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Field, {
        field_name: "Partita IVA",
        required: !_ctx.estera && _ctx.tipo == 0 && !_ctx.disabled,
        errors: _ctx.getErrors('partita_iva')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            modelValue: _ctx.aziendaAutocomplete.selection,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.aziendaAutocomplete.selection) = $event)),
            options: _ctx.aziendaAutocomplete.options,
            disabled: _ctx.disable_autocomplete_azienda,
            taggable: true,
            "clear-on-select": false,
            preserveSearch: true,
            onTag: _cache[3] || (_cache[3] = (value)=>_ctx.aziendaAutocomplete.add({id:-1, partita_iva:value})),
            placeholder: "Partita IVA",
            class: "next-vue-multiselect-single",
            "track-by": "id",
            label: "partita_iva",
            selectLabel: "",
            deselectLabel: "",
            selectedLabel: "",
            "internal-search": false,
            onSearchChange: _ctx.anagraficheAutocompleteSarch
          }, {
            option: _withCtx(({option}) => [
              _createElementVNode("div", _hoisted_6, [
                (option.isTag)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _cache[24] || (_cache[24] = _createTextVNode("Aggiungi partita IVA: ")),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(option.label), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", null, [
                          _cache[25] || (_cache[25] = _createTextVNode("Azienda: ")),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(option.partita_iva), 1)
                        ]),
                        _createElementVNode("span", null, [
                          _cache[26] || (_cache[26] = _createTextVNode("Ragione sociale: ")),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(option.ragione_sociale), 1)
                        ]),
                        _createElementVNode("span", null, [
                          _cache[27] || (_cache[27] = _createTextVNode("CF: ")),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(option.codice_fiscale), 1)
                        ])
                      ])
                    ]))
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "disabled", "onSearchChange"])
        ]),
        _: 1
      }, 8, ["required", "errors"])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_Field, {
        field_name: "Codice fiscale",
        required: !_ctx.estera,
        "model-value": _ctx.codice_fiscale,
        "input-attrs": {disabled:_ctx.disable_dati_azienda},
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:codice_fiscale', $event))),
        errors: _ctx.getErrors('codice_fiscale')
      }, null, 8, ["required", "model-value", "input-attrs", "errors"])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_Field, {
        field_name: "Ragione sociale",
        required: true,
        "model-value": _ctx.ragione_sociale,
        "input-attrs": {disabled:_ctx.disable_dati_azienda},
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:ragione_sociale', $event))),
        errors: _ctx.getErrors('ragione_sociale')
      }, null, 8, ["model-value", "input-attrs", "errors"])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_MapViewer, {
        hide_map: "",
        placeId: _ctx.place_id,
        lat: _ctx.lat,
        lng: _ctx.lng,
        readonly: _ctx.disable_dati_azienda,
        "onUpdate:placeId": _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:place_id', $event))),
        "onUpdate:lat": _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('update:lat', $event))),
        "onUpdate:lng": _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('update:lng', $event))),
        onAddressInformationChange: _ctx.onAddressInformationChange
      }, {
        actual: _withCtx(({actual}) => [
          _createElementVNode("p", null, [
            _cache[28] || (_cache[28] = _createTextVNode("Selezione attuale: ")),
            _createElementVNode("b", null, _toDisplayString(actual?.formatted_address || '----'), 1)
          ])
        ]),
        _: 1
      }, 8, ["placeId", "lat", "lng", "readonly", "onAddressInformationChange"])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_Field, {
          field_name: "Sede legale via",
          required: !_ctx.sede_legale_via,
          "model-value": _ctx.sede_legale_via,
          "input-attrs": {disabled:_ctx.disable_dati_azienda},
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('update:sede_legale_via', $event))),
          placeholder: "Nome via",
          errors: _ctx.getErrors('sede_legale_via')
        }, null, 8, ["required", "model-value", "input-attrs", "errors"])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_Field, {
          field_name: "numero",
          required: !_ctx.sede_legale_numero,
          "model-value": _ctx.sede_legale_numero,
          "input-attrs": {disabled:_ctx.disable_dati_azienda},
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('update:sede_legale_numero', $event))),
          errors: _ctx.getErrors('sede_legale_numero'),
          placeholder: "00"
        }, null, 8, ["required", "model-value", "input-attrs", "errors"])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_Field, {
        required: !_ctx.sl.na_selection,
        field_name: "Sede legale nazione",
        errors: _ctx.getErrors('sede_legale_nazione_id')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            disabled: _ctx.disable_dati_azienda,
            modelValue: _ctx.sl.na_selection,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.sl.na_selection) = $event)),
            options: _ctx.sl.na_options,
            placeholder: "Nazione",
            class: "next-vue-multiselect-single",
            "track-by": "id",
            label: "codice",
            selectLabel: "",
            deselectLabel: "",
            selectedLabel: "",
            "internal-search": false,
            onSearchChange: _ctx.sl.na_search
          }, {
            option: _withCtx(({option}) => [
              _createTextVNode(_toDisplayString(option.codice) + " - " + _toDisplayString(option.nome), 1)
            ]),
            _: 1
          }, 8, ["disabled", "modelValue", "options", "onSearchChange"])
        ]),
        _: 1
      }, 8, ["required", "errors"])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_Field, {
        field_name: "Sede legale cap",
        required: !_ctx.sede_legale_cap,
        "model-value": _ctx.sede_legale_cap,
        "input-attrs": {disabled:_ctx.disable_dati_azienda},
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('update:sede_legale_cap', $event))),
        errors: _ctx.getErrors('sede_legale_cap'),
        placeholder: "CAP"
      }, null, 8, ["required", "model-value", "input-attrs", "errors"])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_22, [
      _createVNode(_component_Field, {
        errors: _ctx.getErrors('sede_legale_provincia_id'),
        required: !_ctx.sl.pa_selection,
        field_name: "Sede legale provincia"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            disabled: _ctx.disable_dati_azienda,
            modelValue: _ctx.sl.pa_selection,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.sl.pa_selection) = $event)),
            options: _ctx.sl.pa_options,
            onTag: _cache[14] || (_cache[14] = (value)=>_ctx.sl.pa_add({id:-1, nome:value})),
            placeholder: "Prov.",
            class: "next-vue-multiselect-single",
            "track-by": "id",
            label: "codice",
            selectLabel: "",
            deselectLabel: "",
            selectedLabel: "",
            "internal-search": false,
            onSearchChange: _ctx.sl.pa_search
          }, null, 8, ["disabled", "modelValue", "options", "onSearchChange"])
        ]),
        _: 1
      }, 8, ["errors", "required"])
    ], 512), [
      [_vShow, _ctx.sl.isNazioneItalia]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_23, [
      _createVNode(_component_Field, {
        errors: _ctx.getErrors('sede_legale_comune_id'),
        required: !_ctx.sl.ca_selection,
        field_name: "Sede legale comune"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            disabled: _ctx.disable_dati_azienda,
            modelValue: _ctx.sl.ca_selection,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.sl.ca_selection) = $event)),
            options: _ctx.sl.ca_options,
            onTag: _cache[16] || (_cache[16] = (value)=>_ctx.sl.ca_add({id:-1, nome:value})),
            placeholder: "Comune",
            class: "next-vue-multiselect-single",
            "track-by": "id",
            label: "nome",
            selectLabel: "",
            deselectLabel: "",
            selectedLabel: "",
            "internal-search": false,
            onSearchChange: _ctx.sl.ca_search
          }, null, 8, ["disabled", "modelValue", "options", "onSearchChange"])
        ]),
        _: 1
      }, 8, ["errors", "required"])
    ], 512), [
      [_vShow, _ctx.sl.isNazioneItalia]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_24, [
      _createVNode(_component_Field, {
        field_name: "Sede legale regione estera",
        required: !_ctx.sede_legale_regione_estero,
        "model-value": _ctx.sede_legale_regione_estero,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('update:sede_legale_regione_estero', $event))),
        "input-attrs": {disabled:_ctx.disable_dati_azienda},
        errors: _ctx.getErrors('sede_legale_regione_estero'),
        placeholder: "Regione estera"
      }, null, 8, ["required", "model-value", "input-attrs", "errors"])
    ], 512), [
      [_vShow, !_ctx.sl.isNazioneItalia]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_25, [
      _createVNode(_component_Field, {
        field_name: "Sede legale città estera",
        required: !_ctx.sede_legale_citta_estero,
        "model-value": _ctx.sede_legale_citta_estero,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('update:sede_legale_citta_estero', $event))),
        "input-attrs": {disabled:_ctx.disable_dati_azienda},
        errors: _ctx.getErrors('sede_legale_citta_estero'),
        placeholder: "Città estera"
      }, null, 8, ["required", "model-value", "input-attrs", "errors"])
    ], 512), [
      [_vShow, !_ctx.sl.isNazioneItalia]
    ]),
    _cache[31] || (_cache[31] = _createElementVNode("div", null, null, -1)),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_Field, {
          field_name: "Numero di dipendenti",
          modelValue: _ctx.numero_dipendenti,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.numero_dipendenti) = $event)),
          type: "number",
          errors: _ctx.getErrors('numero_dipendenti'),
          placeholder: "Numero di dipendenti"
        }, null, 8, ["modelValue", "errors"])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_Field, {
          field_name: "Dipendenti (Anno)",
          modelValue: _ctx.dipendenti,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.dipendenti) = $event)),
          type: "number",
          errors: _ctx.getErrors('dipendenti'),
          placeholder: "Anno"
        }, null, 8, ["modelValue", "errors"])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createVNode(_component_Field, {
        field_name: "Ricavi",
        modelValue: _ctx.ricavi,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.ricavi) = $event)),
        errors: _ctx.getErrors('ricavi'),
        placeholder: "Ricavi"
      }, null, 8, ["modelValue", "errors"])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _cache[29] || (_cache[29] = _createElementVNode("div", { class: "font-bold pb-2" }, "Data chiusura bilancio", -1)),
      _createElementVNode("div", _hoisted_31, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.data_chiusura_bilancio) = $event)),
          type: "date",
          class: "p-2 bg-next-gray-md w-full"
        }, null, 512), [
          [_vModelText, _ctx.data_chiusura_bilancio]
        ])
      ])
    ])
  ]))
}